import pageData from '../../../common/organization/data.json';
import styles from './index.module.less';

function DetailOrganizationPC() {
  const renderPresident = (item) => {
    // 按职位对成员进行分组
    const president = item.value.find((p) => p.rank.includes('会长') && !p.rank.includes('副会长'));
    const executiveVicePresident = item.value.find((p) => p.rank.includes('常务副会长'));
    const vicePresidents = item.value.filter(
      (p) => p.rank.includes('副会长') && !p.rank.includes('常务'),
    );
    const others = item.value.filter((p) => p.rank.includes('监事长') || p.rank.includes('秘书长'));

    return (
      <div key={item.label} className={styles.president}>
        <div className={styles.title}>{item.label}</div>

        {/* 会长单独一行 */}
        {president && (
          <>
            <div className={styles.president__title}>会长</div>
            <div className={`${styles.president__row} ${styles.president__single}`}>
              <div className={styles.president__item}>
                <img src={president.avatarUrl} alt="" className={styles.president__item__avatar} />
                <div>
                  <div className={styles.president__item__name}>{president.name}</div>
                  <div className={styles.president__item__profile}>{president.profile}</div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* 常务副会长单独一行 */}
        {executiveVicePresident && (
          <>
            <div className={styles.president__title}>常务副会长</div>
            <div className={`${styles.president__row} ${styles.president__single}`}>
              <div className={styles.president__item}>
                <img
                  src={executiveVicePresident.avatarUrl}
                  alt=""
                  className={styles.president__item__avatar}
                />
                <div>
                  <div className={styles.president__item__name}>{executiveVicePresident.name}</div>
                  <div className={styles.president__item__profile}>
                    {executiveVicePresident.profile}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* 副会长每行三个 */}
        {vicePresidents.length > 0 && (
          <>
            <div className={`${styles['president__title']} ${styles['president__title--short']}`}>
              副会长
            </div>
            <div className={styles.president__row}>
              {vicePresidents.map((president, index) => (
                <div
                  key={president.name}
                  className={`${styles.president__item__short} ${styles.president__triple}`}
                >
                  <img
                    src={president.avatarUrl}
                    alt=""
                    className={styles.president__item__short__avatar}
                  />
                  <div className={styles.president__item__short__name}>{president.name}</div>
                  <div className={styles.president__item__short__profile}>{president.profile}</div>
                </div>
              ))}
            </div>
          </>
        )}

        {/* 监事长和秘书长并排一行 */}
        {others.length > 0 && (
          <>
            <div className={`${styles['president__title']} ${styles['president__title--short']}`}>
              监事长
              <div
                className={`${styles['president__title']} ${styles['president__title--double']}`}
              >
                秘书长
              </div>
            </div>

            <div className={styles.president__row}>
              {others.map((president) => (
                <div key={president.name} className={`${styles.president__item__double}`}>
                  <img
                    src={president.avatarUrl}
                    alt=""
                    className={styles.president__item__double__avatar}
                  />
                  <div className={styles.president__item__double__name}>{president.name}</div>
                  <div className={styles.president__item__double__profile}>{president.profile}</div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    );
  };

  const renderImg = (item) => (
    <div key={item.label} className={styles.portion}>
      <div className={styles.title}>{item.label}</div>
      <img src={item.imgUrl} alt="" />
    </div>
  );

  return (
    <section className={styles.organization}>
      <div className={styles.organization__container}>
        {pageData.map((item) => (item.type === 'img' ? renderImg(item) : renderPresident(item)))}
      </div>
    </section>
  );
}

export default DetailOrganizationPC;
